import { ProfileSectionContainer_UserFragment } from '@web/federation/gql/graphql'
import { useNavigation } from '@web/hooks/useNavigation'
import { DEFAULT_USER_NICKNAME } from '@web/libs/constants'
import routes from '@web/libs/constants/routes'
import { useProfileTooltip } from '@web/pages/v5/home/ProfileSection/hook'
import { Nullish } from '@web/types'
import Profile, { ProfileProps } from '@web/ui/pages/home/components/Profile'

type Props = {
  user: Nullish<ProfileSectionContainer_UserFragment>
}

const useConvertProfileProps = (user: Props['user']): ProfileProps => {
  const navigation = useNavigation()
  const { showTooltip, tooltipRef } = useProfileTooltip(user)

  if (!user) {
    return {
      login: false,
      nickname: DEFAULT_USER_NICKNAME,
      showTooltip,
      onClickProfile: navigation.goToLogin,
      onClickReviewCount: navigation.goToLogin,
      tooltipRef,
      reviewCount: 0,
    }
  }

  return {
    login: true,
    nickname: user.profile.nickname,
    borderImageUrl: user.profile.border?.imageUrl ?? undefined,
    profileImageUrl: user.profile.imageUrl ?? undefined,
    reviewCount: user.stat.reviewCount ?? 0,
    showTooltip,
    onClickProfile: () => navigation.push({ url: routes.SETTING_PROFILE }),
    onClickReviewCount: () => navigation.push({ url: routes.HOME_MY_REVIEW }),
    tooltipRef,
  }
}

const ProfileSectionContainer = ({ user }: Props) => {
  const props = useConvertProfileProps(user)

  return <Profile {...props} />
}

export default ProfileSectionContainer
